/**
 * Stylus
 *
 * Userstyle manager; its install page is reachable from any origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 2.4.5.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'clngdbkpkpeebahjckkjfobafhncgmne';
export const stylus: ExtensionDefinition = {
  id: ID,
  name: "Stylus",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Userstyle manager; its install page is reachable from any origin.",
  signals: [
    { id: 'war-install-usercss-html', kind: 'web-accessible-resource',
      description: 'Fetch install-usercss.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'install-usercss.html') },
  ],
};
